'use client';

import { jsx } from "react/jsx-runtime";
import { Text } from "../../Text/Text.js";
function renderSuffix({ icon: IconComponent, iconPosition, iconStyle, suffix }, disabled) {
  if (IconComponent && iconPosition === "end") {
    return /* @__PURE__ */ jsx(
      IconComponent,
      {
        color: disabled ? "onLight.disabled.muted" : "onLight.icon.secondary",
        filled: iconStyle === "filled",
        size: "md"
      }
    );
  }
  if (suffix)
    return /* @__PURE__ */ jsx(
      Text,
      {
        "aria-hidden": "true",
        color: disabled ? "onLight.disabled.muted" : "onLight.text.tertiary",
        children: suffix
      }
    );
  return null;
}
export {
  renderSuffix
};
